import React from 'react';
import globalGetPadding from '../../utils/getPadding';
import { getFontSize } from '../../utils/commonFun';

function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
    }
    return undefined;
}

export function CustomHtml({ style, props, formClientWidth }) {
    const isMobile = formClientWidth <= 480;
    const children = props?.contents;
    const cssStyle = {
        color: style?.color ?? undefined,
        backgroundColor: style?.backgroundColor ?? undefined,
        fontFamily: getFontFamily(style?.fontFamily),
        fontSize: getFontSize(style?.fontSize, isMobile),
        textAlign: style?.textAlign ?? undefined,
        padding: globalGetPadding(style?.padding, isMobile),
    };
    if (!children) {
        return <div style={cssStyle} />;
    }
    return <div style={cssStyle} dangerouslySetInnerHTML={{ __html: children }} />;
}
